import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import infinity2 from "../../../../assets/INFINITY.png";
import JobProfile2 from "../../../../assets/images/job-profile2.png";

const Home = () => {
  const [selectedJobType, setSelectedJobType] = useState("");
  const navigate = useNavigate();

  const handleSelectJob = (jobType) => {
    setSelectedJobType(jobType); // Update selected job type
    navigate("#hero"); // Scroll to form section
  };
  const jobOptions = [
    "Development",
    "Sales",
    "Implementation",
    "Support",
    "Admin",
  ];

 

  const initialValues = {
    roleType: "",
    jobType: selectedJobType,
    description: "",
    name: "",
    email: "",
    currentCTC: "",
    resume: null,
  };

  const validationSchema = Yup.object({
    roleType: Yup.string().required("Role type is required"),
    jobType: Yup.string().required("Please select a job type"),
    description: Yup.string()
      .min(20, "Description must be at least 20 characters long")
      .required("Please describe yourself"),
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    currentCTC: Yup.number()
      .typeError("Current CTC must be a number")
      .positive("Current CTC must be greater than zero")
      .required("Current CTC is required"),
    resume: Yup.mixed().required("Resume is required"),
  });

  const handleSubmit = (values) => {
    const mailToLink = `mailto:hr@erpcompany.com?subject=Job Application for ${values.roleType}&body=Dear HR,%0D%0A%0D%0AI am interested in applying for the position of ${values.jobType}.%0D%0A%0D%0ADescription: ${values.description}%0D%0AName: ${values.name}%0D%0AEmail: ${values.email}%0D%0ACurrent CTC: ${values.currentCTC}%0D%0A%0D%0AThank you,%0D%0A${values.name}`;

    window.open(mailToLink, "_self"); // "_self" ensures compatibility with some environments.
  };

  return (
    <React.Fragment>
      <section className="section job-hero-section bg-light  pb-4" id="hero">
        <Container>
          <Row className="justify-content-between align-items-center">
            <Col lg={6}>
              <div>
                <h1 className="display-6 fw-semibold text-capitalize mb-3 lh-base">
                  Shape Your Career With{" "}
                  <span className="text-primary">US</span>
                </h1>
                <p className="lead text-muted lh-base mb-4">
                  Join the growing ERP software industry and make an impact by
                  optimizing business operations. Explore opportunities to work
                  with technologies like .NET, React, and SQL Server while
                  contributing to transformative digital solutions.
                </p>

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ setFieldValue }) => (
                    <Form>
                      {/* Role Type (Radio Buttons) */}
                      <FormGroup>
                        <Label for="roleType">What Do You Want</Label>
                        <div className="d-flex align-items-center">
                          <Field
                            type="radio"
                            id="employment"
                            name="roleType"
                            value="Employment"
                            className="form-check-input"
                          />
                          <Label
                            for="employment"
                            className="form-check-label ms-2"
                          >
                            Employment
                          </Label>
                          <Field
                            type="radio"
                            id="internship"
                            name="roleType"
                            value="Internship"
                            className="form-check-input ms-4"
                          />
                          <Label
                            for="internship"
                            className="form-check-label ms-2"
                          >
                            Internship
                          </Label>
                        </div>
                        <ErrorMessage
                          name="roleType"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>

                      {/* Job Type */}
                      <FormGroup>
                        <Label for="jobType">Job Type</Label>
                        <Field
                          as="select"
                          id="jobType"
                          name="jobType"
                          className="form-control"
                        >
                          <option value="">Select job type</option>
                          {jobOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="jobType"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>

                      
                     
                      {/* Name */}
                      <FormGroup>
                        <Label for="name">Name</Label>
                        <Field
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Enter your name"
                        />
                        <ErrorMessage
                          name="name"
                          component="FormText"
                          className="text-danger"
                        />
                      </FormGroup>

                      {/* Email */}
                      <FormGroup>
                        <Label for="email">Email</Label>
                        <Field
                          id="email"
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="Enter your email"
                        />
                        <ErrorMessage
                          name="email"
                          component="FormText"
                          className="text-danger"
                        />
                      </FormGroup>

                      {/* Current CTC */}
                      <FormGroup>
                        <Label for="currentCTC">Current CTC</Label>
                        <Field
                          id="currentCTC"
                          name="currentCTC"
                          className="form-control"
                          placeholder="Enter your current CTC"
                        />
                        <ErrorMessage
                          name="currentCTC"
                          component="FormText"
                          className="text-danger"
                        />
                      </FormGroup>

                      {/* Describe Yourself (Text Area) */}
                      <FormGroup>
                        <Label for="description">Describe Yourself</Label>
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          className="form-control"
                          rows="4"
                          placeholder="Describe yourself in a few sentences..."
                        />
                        <ErrorMessage
                          name="description"
                          component="FormText"
                          className="text-danger"
                        />
                      </FormGroup>


                      {/* Resume Upload */}
                      <FormGroup>
                        <Label for="resume">Upload Resume</Label>
                        <Input
                          type="file"
                          id="resume"
                          name="resume"
                          onChange={(event) =>
                            setFieldValue(
                              "resume",
                              event.currentTarget.files[0]
                            )
                          }
                        />
                        <ErrorMessage
                          name="resume"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>

                      <Button type="submit" color="primary" className="mt-3">
                        Submit
                      </Button>
                    </Form>
                  )}
                </Formik>

                <ul className="treding-keywords list-inline mb-0 mt-3 fs-13">
                  <li className="list-inline-item text-danger fw-semibold">
                    <i className="mdi mdi-tag-multiple-outline align-middle"></i>{" "}
                    Trending Keywords:
                  </li>
                  <li className="list-inline-item">
                    <Link to="#!" className="link-primary">
                      ERP Development,
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#!" className="link-primary">
                      Business Analysis,
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#!" className="link-primary">
                      Database Management,
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#!" className="link-primary">
                      Full Stack Developer
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4}>
              <div className="position-relative home-img text-center mt-5 mt-lg-0 d-flex flex-column">
                <Card className="p-3 rounded shadow-lg inquiry-box">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <div className="avatar-title bg-warning-subtle text-warning rounded fs-18">
                        <img
                          src={infinity2}
                          alt="Infinity Icon"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            objectFit: "contain",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                    </div>
                    <h5 className="fs-15 lh-base mb-0">
                      Work Inquiry from ERP Enthusiasts
                    </h5>
                  </div>
                </Card>
                <div className="mt-auto">
                  <img
                    src={JobProfile2}
                    alt="ERP Job Profile"
                    className="user-img"
                    style={{ top: "180px" }}
                  />
                </div>
                <div className="circle-effect">
                  <div className="circle"></div>
                  <div className="circle2"></div>
                  <div className="circle3"></div>
                  <div className="circle4"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Home;
